export default "__VITE_ASSET__f550beab__"